module.exports = __webpack_public_path__ + "media/img/scholarships/Maths Year 11-4764201cfdb50035a2c040d64a385400.svg";